import { useState } from 'react';

import { IconButton, SelectDropdown, SlideDown } from '@opositandopn/ui';
import {
  IoAddCircleOutline,
  IoOptions,
  IoOptionsOutline,
} from 'react-icons/io5';

import { Page } from '../../components/shared/page/Page';
import { THEORY_SUBJECT_ID } from '../../constants/subjects';
import {
  AssessmentListFilter,
  AssessmentListFilterForm,
} from '../../features/assessments/components/assessment-list-filter/AssessmentListFilter';
import { MultipleChoiceAssessmentAdminList } from '../../features/assessments/components/multiple-choice-assessment-admin-list/MultipleChoiceAssessmentAdminList';
import { MultipleChoiceAssessmentEditor } from '../../features/assessments/components/multiple-choice-assessment-editor/MultipleChoiceAssessmentEditor';
import { Format } from '../../features/reports/api/useErrorReports';

import styles from './AssessmentListPage.module.scss';

function AssessmentListPage() {
  const [filter, setFilter] = useState<AssessmentListFilterForm>({
    fromTime: new Date('2020-01-01'),
    toTime: new Date(new Date().setHours(23, 59, 59, 999)),
    sort: '-createdAt',
    subject: {
      id: THEORY_SUBJECT_ID,
      name: '',
    },
    perspectives: ['instructor'],
  });

  const [assessmentType, setAssessmentType] =
    useState<Format>('multiple_choice');
  const [showFilters, setShowFilters] = useState(false);
  const [showNew, setShowNew] = useState(false);

  return (
    <Page className={styles['page']}>
      <div className={styles['header']}>
        <IconButton
          icon={<IoAddCircleOutline />}
          onClick={() => {
            setShowNew(true);
          }}
        />
        <SelectDropdown
          className={styles['dropdown']}
          onSelect={(value: string | number) => {
            setAssessmentType(value as Format);
          }}
          options={[
            {
              value: 'multiple_choice',
              label: 'Opción múltiple',
              selected: assessmentType === 'multiple_choice',
            },
            {
              value: 'likert',
              label: 'Escala de Likert',
              disabled: true,
              selected: assessmentType === 'likert',
            },
            {
              value: 'answer',
              label: 'Respuesta escrita',
              disabled: true,
              selected: assessmentType === 'answer',
            },
            {
              value: 'fill_the_gap',
              label: 'Rellenar el espacio',
              disabled: true,
              selected: assessmentType === 'fill_the_gap',
            },
            {
              value: 'true_false',
              label: 'Verdadero o Falso',
              disabled: true,
              selected: assessmentType === 'true_false',
            },
          ]}
        />
        <IconButton
          icon={<IoOptionsOutline />}
          flipped={showFilters}
          flipIcon={<IoOptions />}
          onClick={() => {
            setShowFilters(!showFilters);
          }}
        />
      </div>
      <SlideDown className={styles['slide-down']}>
        {showFilters ? (
          <AssessmentListFilter
            values={filter}
            onSubmit={(values) => {
              setFilter(values);
            }}
            onClear={() => {
              setFilter({
                fromTime: new Date('2020-01-01'),
                toTime: new Date(new Date().setHours(23, 59, 59, 999)),
                sort: '-createdAt',
                subject: {
                  id: THEORY_SUBJECT_ID,
                  name: '',
                },
                perspectives: ['instructor'],
              });
            }}
          />
        ) : null}
      </SlideDown>
      {assessmentType === 'multiple_choice' && (
        <MultipleChoiceAssessmentAdminList filter={filter} />
      )}
      {assessmentType === 'multiple_choice' && (
        <MultipleChoiceAssessmentEditor
          open={showNew}
          onClose={() => setShowNew(false)}
        />
      )}
    </Page>
  );
}

export { AssessmentListPage };
